import React from "react";
function NotFound() {
  return (
    <div className="conatiner p-5 mb-5">
      <div className="row text-center">
        <h1 className="mt-5">404 NOT FOUND</h1>
        <p className="mt-2">
          Sorry the page you are looking for does not exist
        </p>
      </div>
    </div>
  );
}

export default NotFound;
